import { Component, OnInit } from '@angular/core';
import Typed from 'typed.js';
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  private typewriter_text: string = "We are PATCH INFOTECH";
  private typewriter_display: string = "";

  constructor() { }

  ngOnInit(): void {
    this.typingCallback(this);


    const options = {
      strings: [' GET', ' PUT', 'POST', 'PATCH INFOTECH'],
      typeSpeed: 100,
      backSpeed: 100,
      showCursor: true,
      cursorChar: '|',
      loop: false
  };
  
  const typed = new Typed('.typed-element', options);
  
  }

  typingCallback(that) {
    let total_length = that.typewriter_text.length;
    let current_length = that.typewriter_display.length;
    if (current_length < total_length) {
      that.typewriter_display += that.typewriter_text[current_length];
      setTimeout(that.typingCallback, 100, that);
    } else {
     
      that.typewriter_display = "We are PATCH INFOTECH";
    }
  }


  onKnowMore(){
  document.getElementById("forScroll").scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
